import React from 'react';
import PageContainer from '../layout/PageContainer';
import OperacionesLibrosVenta from './OperacionesLibrosVenta';

const OperacionesLibrosVentaContainer = () => {
  const breadcrumbs = [
    { id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' },
    { id: 1, name: 'OPERACIONES', url: '/operaciones/libros-venta' },
    { id: 2, name: 'LIBROS DE VENTA' },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <OperacionesLibrosVenta />
    </PageContainer>
  );
};

export default OperacionesLibrosVentaContainer;
